/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from "react";
import DTOWithdrawModal from "./DTOWithdrawModal";
import WithdrawModalPresenter from "./WithdrawModalPresenter";
import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";
import toast from "react-hot-toast";
import { offBoardingService } from "../../../../api/services/offBoardingService";
import { setOffBoardingList } from "../../../../infra/aggregates/myProfile/offBoardingAggregates/offBoardingListSlice";
import { setLoading } from "../../../../infra/aggregates/LoaderSlice";
import { useTranslation } from "react-i18next";

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  selectedOffBoardingId: number;
}

const WithdrawModalController = ({
  isModalOpen,
  closeModal,
  selectedOffBoardingId,
}: ModalInterface) => {
  const selector = useAppSelector((state) => state.authSlice);
  const { t } = useTranslation();
  const [reasonsType, setReasonsType] = useState([]);
  const dispatch = useAppDispatch();

  const getData = (data: any) => {
    withdrawOffboarding(data);
  };

  const getReasons = (data: any) => {
    setReasonsType(data);
  };

  async function withdrawOffboarding(data: any) {
    const empId: any = selector.emp_id;
    const companyId: any = selector.company_id;

    const formData = new FormData();
    formData.append("id", data.id);
    formData.append("emp_id", empId);
    formData.append("company_id", companyId);
    formData.append("reason", data.reason);
    formData.append("remarks", data.remarks);
    formData.append("attachment", data.attachment);
    dispatch(setLoading(true));
    await offBoardingService
      .withdrawEmpBoarding(formData)
      .then((response) => {
        if (response.response == "success") {
          //dispatch(setOffBoardingList({}));
          dispatch(setOffBoardingList(response?.data));
          dispatch(setLoading(false));
          toast.success(t("Withdraw Successfully"));
        }
      })
      .catch((err) => {
        dispatch(setLoading(false));
        toast.error(err?.response?.data?.message);
      });
  }

  return (
    <>
      <DTOWithdrawModal setReasonsForResignations={getReasons} />

      <WithdrawModalPresenter
        callBackGetData={getData}
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        reasonsType={reasonsType}
        selectedOffBoardingId={selectedOffBoardingId}
        trans={t}
      />
    </>
  );
};

export default WithdrawModalController;
